import { useState, useEffect } from "react";
import Style from "./ApartmentsGeneratorStyle";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import api from "../../services/api";
import { FaTrashAlt } from "react-icons/fa";
import PageTitle from "../../components/PageTitle";

export default function ApartmentsGenerator(props) {

  const [apartments, setApartments] = useState([] as any);
  const [plans, setPlans] = useState([] as any[]);
  const [totalFloor, setTotalFloor] = useState("1");
  const [startAtGround, setStartAtGround] = useState(false);

  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [message, setMessage] = useState({ success: "", error: "" });

  const blockId = props.match.params.blockId
  useEffect(() => {
    LoadPlans()
  }, []);

  async function LoadPlans() {
    try {
      const result = await api.get(`/plans`);
      if (result.data.success) {
        setLoading(false);
        setPlans(result.data.plans);
      }
    } catch (error) {
      setLoading(false);
    }

  }

  async function onCreate() {
    try {
      let aps: any[] = [];
      apartments.forEach(ap => {
        aps.push({ apartmentNumber: ap.apartmentNumber, planId: ap.planId })
      });
      const data = {
        floors: totalFloor,
        template: aps,
        startAtGround,
      }

      await api.post(`/enterprises/blocks/${blockId}`, data);
      onClosePopup();
      setMessage({ success: `Apartamentos criados com sucesso!`, error: "" });
      setLoading(false);
      props.history.goBack()
    }
    catch (error: any) {
      setLoading(false);
      setMessage({ success: "", error: error?.response?.data?.message });
      onClosePopup();
    }
  }

  function onOpenPopUp() {
    setShowPopup(true);
  }

  function onClosePopup() {
    setShowPopup(false);
  }

  function onAddApartment() {
    const newApPlanId = plans.length > 0 ? plans[0].id : null;
    const ap = { apartmentNumber: "", planId: newApPlanId };
    const newApartments: any[] = apartments;
    newApartments.push(ap);
    setApartments([...newApartments])
  }

  function onChange(index, e) {
    let newApartment = apartments[index]
    newApartment[e.target.name] = e.target.value;
    let listAp = apartments.map((value, i) => {
      if (index === i) {
        return newApartment;
      }
      return value;
    })
    setApartments(listAp);
    onDisable();
  }


  function onDisable() {
    apartments.forEach(ap => {
      if (ap.apartmentNumber.trim() !== "") {
        setDisable(false);
        return;
      }
      else {
        setDisable(true)
      }
    });
  }

  return (
    <Style>
      <PageTitle title="Gerar apartamentos" />
      <TwoButtonsModal
        show={showPopup}
        onHide={onClosePopup}
        loading={loading}
        title={"Cadastro de apartamentos"}
        body={"Você tem certeza que deseja gerar este template de apartamento?"}
        secondaryText="Fechar"
        secondaryOnClick={onClosePopup}
        secondaryDisabled={loading}
        primaryText="Confirmar"
        primaryOnClick={() => onCreate()}
        primaryDisabled={loading}
      />
      {message.error && <p className="alert alert-error">Erro: {message.error}</p>}
      {message.success && <p className="alert alert-info">{message.success}</p>}
      <button className=" btn-secondary button" onClick={() => props.history.goBack()} >Voltar</button>
      <section className="table-title">
        <h1>Modelos de andares</h1>
        <button onClick={e => onAddApartment()}>Adicionar</button>
      </section>
      <table className="table table-striped table-bordered table-hover main-table">
        <thead >
          <tr>
            <th>Final Apartamento</th>
            <th>Planta</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {apartments.length > 0 && apartments.map((apartment, index) => {
            return (
              <tr key={index} >
                <td>
                  <input
                    name="apartmentNumber"
                    type="text"

                    disabled={loading}
                    value={apartment.apartmentNumber}
                    placeholder="ex: 01, 02, 03..."
                    onChange={e => onChange(index, e)}
                  />
                </td>
                <td>
                  <select
                    name="planId"
                    value={apartment.planId}
                    onChange={e => onChange(index, e)}>
                    {plans.length > 0 && plans[0].id && plans.map(f =>
                      <option key={f.id} value={f.id}>{f.name}</option>
                    )}
                  </select>
                </td>
                <td className="action">
                  <button onClick={() => setApartments(apartments.filter(ap => ap !== apartment))}>
                    <FaTrashAlt className="icon" /></button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div>
        <label htmlFor="floors">Total de andares:</label>
        <input
          id="floors"
          type="number"
          min="1"
          max="100"
          value={totalFloor}
          onChange={e => setTotalFloor(e.target.value)}
        />
      </div>
      <div className="centralizedDiv">
        <label>Inicia no térreo? (Ap 001 em vez de 101)</label>
        <input id="startAtGroundFloor" type="checkbox"
          checked={startAtGround}
          onChange={(newValue) => {
            setStartAtGround(newValue.target.checked);
          }} />
      </div>
      <div>
        <button
          className="btn btn-success btn-lg mt-4 button"
          type="button"
          disabled={disable}
          onClick={e => {
            e.preventDefault();
            onOpenPopUp();
          }}>Gerar
        </button>
      </div>
    </Style >
  )
}
